<template>
  <svg width="64" height="30" viewBox="0 0 64 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_409_2)">
    <path style="mix-blend-mode:multiply" d="M0.972656 7.01258L0.972656 13.9726C0.972656 17.8456 4.09432 20.9852 7.94509 20.9852L55.5564 20.9852C59.4072 20.9852 62.5288 17.8456 62.5288 13.9726L62.5288 7.01258C62.5288 3.13961 59.4072 -4.31722e-05 55.5564 -4.32181e-05L7.94509 -4.37859e-05C4.09432 -4.38318e-05 0.972656 3.13961 0.972656 7.01258Z" fill="url(#paint0_linear_409_2)"/>
    <path d="M51.4287 6.22717L51.4287 6.45508L58.3035 6.45508L58.3035 6.22717L51.4287 6.22717Z" fill="black"/>
    <path d="M50.9058 3.80068L50.9058 5.55032C50.9058 5.93762 51.2179 6.25159 51.603 6.25159L58.3035 6.25159C58.6886 6.25159 59.0008 5.93762 59.0008 5.55032L59.0008 3.80068C59.0008 3.41338 58.6886 3.09941 58.3035 3.09941L51.603 3.09941C51.2179 3.09941 50.9058 3.41338 50.9058 3.80068Z" fill="url(#paint1_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 6.25159L58.3036 5.44864L58.7742 5.44864L58.7742 6.06575C58.6487 6.18146 58.4849 6.25159 58.3036 6.25159Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 5.45217L57.1741 6.34277L57.6447 6.34277L57.6447 5.45217L57.1741 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 5.45217L56.048 6.34277L56.5186 6.34277L56.5186 5.45217L56.048 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 5.45217L54.9185 6.34277L55.3891 6.34277L55.3891 5.45217L54.9185 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 5.45217L53.7889 6.34277L54.2596 6.34277L54.2596 5.45217L53.7889 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 5.45217L52.6594 6.34277L53.1301 6.34277L53.1301 5.45217L52.6594 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 5.45217L51.5333 6.34277L52.004 6.34277L52.004 5.45217L51.5333 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M58.7742 3.99353L58.3036 3.99353L58.3036 3.10293C58.4849 3.10293 58.6487 3.17656 58.7742 3.28876L58.7742 3.99353Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 3.10293L57.1741 3.99353L57.6447 3.99353L57.6447 3.10293L57.1741 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 3.10293L56.048 3.99353L56.5186 3.99353L56.5186 3.10293L56.048 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 3.10293L54.9185 3.99353L55.3891 3.99353L55.3891 3.10293L54.9185 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 3.10293L53.7889 3.99353L54.2596 3.99353L54.2596 3.10293L53.7889 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 3.10293L52.6594 3.99353L53.1301 3.99353L53.1301 3.10293L52.6594 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 3.10293L51.5333 3.99353L52.004 3.99353L52.004 3.10293L51.5333 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 4.23196L57.676 5.12256L58.1467 5.12256L58.1467 4.23196L57.676 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 4.23196L56.5465 5.12256L57.0172 5.12256L57.0172 4.23196L56.5465 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 4.23196L55.4204 5.12256L55.8911 5.12256L55.8911 4.23196L55.4204 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 4.23196L54.2909 5.12256L54.7615 5.12256L54.7615 4.23196L54.2909 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 4.23196L53.1614 5.12256L53.632 5.12256L53.632 4.23196L53.1614 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 4.23196L52.0319 5.12256L52.5025 5.12256L52.5025 4.23196L52.0319 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 4.23196L58.3036 5.12256L58.7742 5.12256L58.7742 4.23196L58.3036 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 4.23196L57.1741 5.12256L57.6447 5.12256L57.6447 4.23196L57.1741 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 4.23196L56.048 5.12256L56.5186 5.12256L56.5186 4.23196L56.048 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 4.23196L54.9185 5.12256L55.3891 5.12256L55.3891 4.23196L54.9185 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 4.23196L53.7889 5.12256L54.2596 5.12256L54.2596 4.23196L53.7889 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 4.23196L52.6594 5.12256L53.1301 5.12256L53.1301 4.23196L52.6594 4.23196Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 4.23196L51.5333 5.12256L52.004 5.12256L52.004 4.23196L51.5333 4.23196Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 3.10293L57.676 3.99353L58.1467 3.99353L58.1467 3.10293L57.676 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 3.10293L56.5465 3.99353L57.0172 3.99353L57.0172 3.10293L56.5465 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 3.10293L55.4204 3.99353L55.8911 3.99353L55.8911 3.10293L55.4204 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 3.10293L54.2909 3.99353L54.7615 3.99353L54.7615 3.10293L54.2909 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 3.10293L53.1614 3.99353L53.632 3.99353L53.632 3.10293L53.1614 3.10293Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 3.10293L52.0319 3.99353L52.5025 3.99353L52.5025 3.10293L52.0319 3.10293Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 5.45217L57.676 6.34277L58.1467 6.34277L58.1467 5.45217L57.676 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 5.45217L56.5465 6.34277L57.0172 6.34277L57.0172 5.45217L56.5465 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 5.45217L55.4204 6.34277L55.8911 6.34277L55.8911 5.45217L55.4204 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 5.45217L54.2909 6.34277L54.7615 6.34277L54.7615 5.45217L54.2909 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 5.45217L53.1614 6.34277L53.632 6.34277L53.632 5.45217L53.1614 5.45217Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 5.45217L52.0319 6.34277L52.5025 6.34277L52.5025 5.45217L52.0319 5.45217Z" fill="#636363"/>
    </g>
    </g>
    <path d="M50.9058 7.15627L50.9058 8.90592C50.9058 9.29321 51.2179 9.60718 51.603 9.60718L58.3035 9.60718C58.6886 9.60718 59.0008 9.29321 59.0008 8.90592L59.0008 7.15627C59.0008 6.76897 58.6886 6.455 58.3035 6.455L51.603 6.455C51.2179 6.455 50.9058 6.76897 50.9058 7.15627Z" fill="url(#paint2_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 9.60718L58.3036 8.80423L58.7742 8.80423L58.7742 9.42134C58.6487 9.53705 58.4849 9.60718 58.3036 9.60718Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 8.80776L57.1741 9.69836L57.6447 9.69836L57.6447 8.80776L57.1741 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 8.80776L56.048 9.69836L56.5186 9.69836L56.5186 8.80776L56.048 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 8.80776L54.9185 9.69836L55.3891 9.69836L55.3891 8.80776L54.9185 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 8.80776L53.7889 9.69836L54.2596 9.69836L54.2596 8.80776L53.7889 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 8.80776L52.6594 9.69836L53.1301 9.69836L53.1301 8.80776L52.6594 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 8.80776L51.5333 9.69836L52.004 9.69836L52.004 8.80776L51.5333 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M58.7742 7.34912L58.3036 7.34912L58.3036 6.45852C58.4849 6.45852 58.6487 6.53215 58.7742 6.64435L58.7742 7.34912Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 6.45852L57.1741 7.34912L57.6447 7.34912L57.6447 6.45852L57.1741 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 6.45852L56.048 7.34912L56.5186 7.34912L56.5186 6.45852L56.048 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 6.45852L54.9185 7.34912L55.3891 7.34912L55.3891 6.45852L54.9185 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 6.45852L53.7889 7.34912L54.2596 7.34912L54.2596 6.45852L53.7889 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 6.45852L52.6594 7.34912L53.1301 7.34912L53.1301 6.45852L52.6594 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 6.45852L51.5333 7.34912L52.004 7.34912L52.004 6.45852L51.5333 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 7.58755L57.676 8.47815L58.1467 8.47815L58.1467 7.58755L57.676 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 7.58755L56.5465 8.47815L57.0172 8.47815L57.0172 7.58755L56.5465 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 7.58755L55.4204 8.47815L55.8911 8.47815L55.8911 7.58755L55.4204 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 7.58755L54.2909 8.47815L54.7615 8.47815L54.7615 7.58755L54.2909 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 7.58755L53.1614 8.47815L53.632 8.47815L53.632 7.58755L53.1614 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 7.58755L52.0319 8.47815L52.5025 8.47815L52.5025 7.58755L52.0319 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 7.58755L58.3036 8.47815L58.7742 8.47815L58.7742 7.58755L58.3036 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 7.58755L57.1741 8.47815L57.6447 8.47815L57.6447 7.58755L57.1741 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 7.58755L56.048 8.47815L56.5186 8.47815L56.5186 7.58755L56.048 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 7.58755L54.9185 8.47815L55.3891 8.47815L55.3891 7.58755L54.9185 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 7.58755L53.7889 8.47815L54.2596 8.47815L54.2596 7.58755L53.7889 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 7.58755L52.6594 8.47815L53.1301 8.47815L53.1301 7.58755L52.6594 7.58755Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 7.58755L51.5333 8.47815L52.004 8.47815L52.004 7.58755L51.5333 7.58755Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 6.45852L57.676 7.34912L58.1467 7.34912L58.1467 6.45852L57.676 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 6.45852L56.5465 7.34912L57.0172 7.34912L57.0172 6.45852L56.5465 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 6.45852L55.4204 7.34912L55.8911 7.34912L55.8911 6.45852L55.4204 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 6.45852L54.2909 7.34912L54.7615 7.34912L54.7615 6.45852L54.2909 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 6.45852L53.1614 7.34912L53.632 7.34912L53.632 6.45852L53.1614 6.45852Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 6.45852L52.0319 7.34912L52.5025 7.34912L52.5025 6.45852L52.0319 6.45852Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 8.80776L57.676 9.69836L58.1467 9.69836L58.1467 8.80776L57.676 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 8.80776L56.5465 9.69836L57.0172 9.69836L57.0172 8.80776L56.5465 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 8.80776L55.4204 9.69836L55.8911 9.69836L55.8911 8.80776L55.4204 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 8.80776L54.2909 9.69836L54.7615 9.69836L54.7615 8.80776L54.2909 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 8.80776L53.1614 9.69836L53.632 9.69836L53.632 8.80776L53.1614 8.80776Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 8.80776L52.0319 9.69836L52.5025 9.69836L52.5025 8.80776L52.0319 8.80776Z" fill="#636363"/>
    </g>
    </g>
    <path d="M51.4287 23.8603L51.4287 24.0883L58.3035 24.0883L58.3035 23.8603L51.4287 23.8603Z" fill="black"/>
    <path d="M50.9058 24.7615L50.9058 26.5111C50.9058 26.8984 51.2179 27.2124 51.603 27.2124L58.3035 27.2124C58.6886 27.2124 59.0008 26.8984 59.0008 26.5111L59.0008 24.7615C59.0008 24.3742 58.6886 24.0602 58.3035 24.0602L51.603 24.0602C51.2179 24.0602 50.9058 24.3742 50.9058 24.7615Z" fill="url(#paint3_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 24.0638L58.3036 24.8667L58.7742 24.8667L58.7742 24.2496C58.6487 24.1339 58.4849 24.0638 58.3036 24.0638Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 23.9761L57.1741 24.8667L57.6447 24.8667L57.6447 23.9761L57.1741 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 23.9761L56.048 24.8667L56.5186 24.8667L56.5186 23.9761L56.048 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 23.9761L54.9185 24.8667L55.3891 24.8667L55.3891 23.9761L54.9185 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 23.9761L53.7889 24.8667L54.2596 24.8667L54.2596 23.9761L53.7889 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 23.9761L52.6594 24.8667L53.1301 24.8667L53.1301 23.9761L52.6594 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 23.9761L51.5333 24.8667L52.004 24.8667L52.004 23.9761L51.5333 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M58.7742 26.3218L58.3036 26.3218L58.3036 27.2124C58.4849 27.2124 58.6487 27.1388 58.7742 27.0266L58.7742 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 26.3218L57.1741 27.2124L57.6447 27.2124L57.6447 26.3218L57.1741 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 26.3218L56.048 27.2124L56.5186 27.2124L56.5186 26.3218L56.048 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 26.3218L54.9185 27.2124L55.3891 27.2124L55.3891 26.3218L54.9185 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 26.3218L53.7889 27.2124L54.2596 27.2124L54.2596 26.3218L53.7889 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 26.3218L52.6594 27.2124L53.1301 27.2124L53.1301 26.3218L52.6594 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 26.3218L51.5333 27.2124L52.004 27.2124L52.004 26.3218L51.5333 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 25.1928L57.676 26.0834L58.1467 26.0834L58.1467 25.1928L57.676 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 25.1928L56.5465 26.0834L57.0172 26.0834L57.0172 25.1928L56.5465 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 25.1928L55.4204 26.0834L55.8911 26.0834L55.8911 25.1928L55.4204 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 25.1928L54.2909 26.0834L54.7615 26.0834L54.7615 25.1928L54.2909 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 25.1928L53.1614 26.0834L53.632 26.0834L53.632 25.1928L53.1614 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 25.1928L52.0319 26.0834L52.5025 26.0834L52.5025 25.1928L52.0319 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 25.1928L58.3036 26.0834L58.7742 26.0834L58.7742 25.1928L58.3036 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 25.1928L57.1741 26.0834L57.6447 26.0834L57.6447 25.1928L57.1741 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 25.1928L56.048 26.0834L56.5186 26.0834L56.5186 25.1928L56.048 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 25.1928L54.9185 26.0834L55.3891 26.0834L55.3891 25.1928L54.9185 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 25.1928L53.7889 26.0834L54.2596 26.0834L54.2596 25.1928L53.7889 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 25.1928L52.6594 26.0834L53.1301 26.0834L53.1301 25.1928L52.6594 25.1928Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 25.1928L51.5333 26.0834L52.004 26.0834L52.004 25.1928L51.5333 25.1928Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 26.3218L57.676 27.2124L58.1467 27.2124L58.1467 26.3218L57.676 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 26.3218L56.5465 27.2124L57.0172 27.2124L57.0172 26.3218L56.5465 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 26.3218L55.4204 27.2124L55.8911 27.2124L55.8911 26.3218L55.4204 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 26.3218L54.2909 27.2124L54.7615 27.2124L54.7615 26.3218L54.2909 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 26.3218L53.1614 27.2124L53.632 27.2124L53.632 26.3218L53.1614 26.3218Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 26.3218L52.0319 27.2124L52.5025 27.2124L52.5025 26.3218L52.0319 26.3218Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 23.9761L57.676 24.8667L58.1467 24.8667L58.1467 23.9761L57.676 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 23.9761L56.5465 24.8667L57.0172 24.8667L57.0172 23.9761L56.5465 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 23.9761L55.4204 24.8667L55.8911 24.8667L55.8911 23.9761L55.4204 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 23.9761L54.2909 24.8667L54.7615 24.8667L54.7615 23.9761L54.2909 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 23.9761L53.1614 24.8667L53.632 24.8667L53.632 23.9761L53.1614 23.9761Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 23.9761L52.0319 24.8667L52.5025 24.8667L52.5025 23.9761L52.0319 23.9761Z" fill="#636363"/>
    </g>
    </g>
    <path d="M50.9058 21.4094L50.9058 23.1591C50.9058 23.5464 51.2179 23.8604 51.603 23.8604L58.3035 23.8604C58.6886 23.8604 59.0008 23.5464 59.0008 23.1591L59.0008 21.4094C59.0008 21.0221 58.6886 20.7082 58.3035 20.7082L51.603 20.7082C51.2179 20.7082 50.9058 21.0221 50.9058 21.4094Z" fill="url(#paint4_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 20.7082L58.3036 21.5111L58.7742 21.5111L58.7742 20.894C58.6487 20.7783 58.4849 20.7082 58.3036 20.7082Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 20.6205L57.1741 21.5111L57.6447 21.5111L57.6447 20.6205L57.1741 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 20.6205L56.048 21.5111L56.5186 21.5111L56.5186 20.6205L56.048 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 20.6205L54.9185 21.5111L55.3891 21.5111L55.3891 20.6205L54.9185 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 20.6205L53.7889 21.5111L54.2596 21.5111L54.2596 20.6205L53.7889 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 20.6205L52.6594 21.5111L53.1301 21.5111L53.1301 20.6205L52.6594 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 20.6205L51.5333 21.5111L52.004 21.5111L52.004 20.6205L51.5333 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M58.7742 22.9662L58.3036 22.9662L58.3036 23.8568C58.4849 23.8568 58.6487 23.7867 58.7742 23.671L58.7742 22.9662Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 22.9697L57.1741 23.8604L57.6447 23.8604L57.6447 22.9697L57.1741 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 22.9697L56.048 23.8604L56.5186 23.8604L56.5186 22.9697L56.048 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 22.9697L54.9185 23.8604L55.3891 23.8604L55.3891 22.9697L54.9185 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 22.9697L53.7889 23.8604L54.2596 23.8604L54.2596 22.9697L53.7889 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 22.9697L52.6594 23.8604L53.1301 23.8604L53.1301 22.9697L52.6594 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 22.9697L51.5333 23.8604L52.004 23.8604L52.004 22.9697L51.5333 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 21.8407L57.676 22.7313L58.1467 22.7313L58.1467 21.8407L57.676 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 21.8407L56.5465 22.7313L57.0172 22.7313L57.0172 21.8407L56.5465 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 21.8407L55.4204 22.7313L55.8911 22.7313L55.8911 21.8407L55.4204 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 21.8407L54.2909 22.7313L54.7615 22.7313L54.7615 21.8407L54.2909 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 21.8407L53.1614 22.7313L53.632 22.7313L53.632 21.8407L53.1614 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 21.8407L52.0319 22.7313L52.5025 22.7313L52.5025 21.8407L52.0319 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M58.3036 21.8407L58.3036 22.7313L58.7742 22.7313L58.7742 21.8407L58.3036 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M57.1741 21.8407L57.1741 22.7313L57.6447 22.7313L57.6447 21.8407L57.1741 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.048 21.8407L56.048 22.7313L56.5186 22.7313L56.5186 21.8407L56.048 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.9185 21.8407L54.9185 22.7313L55.3891 22.7313L55.3891 21.8407L54.9185 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.7889 21.8407L53.7889 22.7313L54.2596 22.7313L54.2596 21.8407L53.7889 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.6594 21.8407L52.6594 22.7313L53.1301 22.7313L53.1301 21.8407L52.6594 21.8407Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M51.5333 21.8407L51.5333 22.7313L52.004 22.7313L52.004 21.8407L51.5333 21.8407Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 22.9697L57.676 23.8604L58.1467 23.8604L58.1467 22.9697L57.676 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 22.9697L56.5465 23.8604L57.0172 23.8604L57.0172 22.9697L56.5465 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 22.9697L55.4204 23.8604L55.8911 23.8604L55.8911 22.9697L55.4204 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 22.9697L54.2909 23.8604L54.7615 23.8604L54.7615 22.9697L54.2909 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 22.9697L53.1614 23.8604L53.632 23.8604L53.632 22.9697L53.1614 22.9697Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 22.9697L52.0319 23.8604L52.5025 23.8604L52.5025 22.9697L52.0319 22.9697Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M57.676 20.6205L57.676 21.5111L58.1467 21.5111L58.1467 20.6205L57.676 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M56.5465 20.6205L56.5465 21.5111L57.0172 21.5111L57.0172 20.6205L56.5465 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M55.4204 20.6205L55.4204 21.5111L55.8911 21.5111L55.8911 20.6205L55.4204 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M54.2909 20.6205L54.2909 21.5111L54.7615 21.5111L54.7615 20.6205L54.2909 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M53.1614 20.6205L53.1614 21.5111L53.632 21.5111L53.632 20.6205L53.1614 20.6205Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M52.0319 20.6205L52.0319 21.5111L52.5025 21.5111L52.5025 20.6205L52.0319 20.6205Z" fill="#636363"/>
    </g>
    </g>
    <path d="M24.2292 4.97535L24.2292 9.41785L29.6608 9.41785L29.6608 4.97535L24.2292 4.97535Z" fill="url(#paint5_linear_409_2)"/>
    <path d="M24.2292 21.0167L24.2292 25.4592L29.6608 25.4592L29.6608 21.0167L24.2292 21.0167Z" fill="url(#paint6_linear_409_2)"/>
    <path d="M1.0459 9.74753L1.0459 20.6451L26.5859 20.6451L26.5859 9.74753L1.0459 9.74753Z" fill="url(#paint7_linear_409_2)"/>
    <path d="M2.09167 10.7994L2.09167 19.5933L25.54 19.5933L25.54 10.7994L2.09167 10.7994Z" fill="url(#paint8_linear_409_2)"/>
    <path d="M21.9109 10.4908L21.9109 19.6002L26.945 19.6002L26.945 10.4908L21.9109 10.4908Z" fill="url(#paint9_linear_409_2)"/>
    <path d="M63.3166 8.09247L63.3166 22.265C63.3166 24.5476 60.7787 26.3989 58.5091 26.3989L27.6875 25.7327C27.0077 25.7327 26.4534 21.0097 26.4534 15.1822C26.4534 9.35475 27.0042 4.63174 27.6875 4.63174L58.5091 3.96204C60.7787 3.96204 63.3166 5.81337 63.3166 8.09598L63.3166 8.09247Z" fill="url(#paint10_linear_409_2)"/>
    <path d="M58.5092 3.95861C60.7787 3.95861 63.3167 5.80994 63.3167 8.09255L63.3167 22.2651C63.3167 24.5477 60.7787 26.399 58.5092 26.399L50.7245 26.7496L50.7245 3.60798L58.5092 3.95861Z" fill="url(#paint11_linear_409_2)"/>
    <path style="mix-blend-mode:multiply" d="M53.7993 8.29943C49.3578 7.70335 45.7008 7.66478 45.6276 8.21177C45.5544 8.75875 49.0964 9.68442 53.5378 10.2805C57.9793 10.8766 62.3335 10.9151 62.4067 10.3681C62.48 9.82116 58.2407 8.8955 53.7993 8.29943Z" fill="url(#paint12_radial_409_2)"/>
    <path style="mix-blend-mode:multiply" d="M58.1258 9.02871C59.5098 9.21454 61.7131 9.43193 62.8391 9.65984L62.8391 11.4165C61.6364 11.3429 59.3425 11.2061 57.8608 11.0098C53.4194 10.4137 49.8774 9.48803 49.9506 8.94105C50.0238 8.39406 53.6808 8.43263 58.1223 9.02871L58.1258 9.02871Z" fill="url(#paint13_radial_409_2)"/>
    <path style="mix-blend-mode:multiply" d="M51.3554 8.03636C46.914 7.44029 43.2569 7.40172 43.1837 7.94871C43.1105 8.49569 46.6525 9.42136 51.094 10.0174C55.5354 10.6135 59.8897 10.6521 59.9629 10.1051C60.0361 9.5581 55.7969 8.63244 51.3554 8.03636Z" fill="url(#paint14_radial_409_2)"/>
    <path style="mix-blend-mode:screen" d="M50.836 3.61145L58.5092 3.95858C59.0217 3.95858 60.2 4.29518 60.6532 4.4705C60.4789 4.51958 60.3046 4.32323 60.1129 4.35479C56.794 4.88775 53.9074 4.08831 51.6971 5.48382C51.0278 5.90808 50.7663 5.59953 50.7245 4.96839L50.7245 4.53711C50.7384 4.25661 50.7803 3.94104 50.836 3.61496L50.836 3.61145Z" fill="url(#paint15_linear_409_2)"/>
    <path style="mix-blend-mode:screen" d="M50.836 26.7355L58.5092 26.3884C59.0217 26.3884 60.2 26.1254 60.6532 25.9536C60.4789 25.9045 60.3046 26.0237 60.1129 25.9957C56.794 25.4627 53.9074 26.2622 51.6971 24.8666C51.0278 24.4424 50.7663 24.7509 50.7245 25.3821L50.7245 25.8169C50.7384 26.0974 50.7803 26.4094 50.836 26.739L50.836 26.7355Z" fill="url(#paint16_linear_409_2)"/>
    <path style="mix-blend-mode:screen" d="M53.7574 23.5238C56.5325 23.5238 59.8165 22.5736 61.9082 20.9888C61.8629 21.3113 60.6288 24.5091 57.9932 25.014C55.2182 25.547 53.3879 24.7475 51.5402 26.143C50.4316 26.9811 50.6547 24.9579 51.0068 23.2048C51.8958 23.4116 52.8162 23.5238 53.7574 23.5238Z" fill="url(#paint17_linear_409_2)"/>
    <path d="M63.3167 8.09247L63.3167 22.265C63.3167 24.5476 60.7788 26.3989 58.5092 26.3989L57.9933 26.3989C60.2628 26.3989 62.8008 24.5476 62.8008 22.265L62.8008 8.08897C62.8008 5.80636 60.2628 3.95503 57.9933 3.95503L58.5092 3.95503C60.7788 3.95503 63.3167 5.80636 63.3167 8.08897L63.3167 8.09247Z" fill="url(#paint18_linear_409_2)"/>
    <path d="M51.5367 9.02866L62.4765 10.5294C62.7763 10.5294 63.0169 12.6121 63.0169 15.1822C63.0169 17.7524 62.7763 19.8351 62.4765 19.8351L51.5367 21.3358L51.5367 9.03217L51.5367 9.02866Z" fill="url(#paint19_linear_409_2)"/>
    <path d="M60.1443 4.61076C59.9177 4.58973 59.6911 4.58973 59.4645 4.61076C59.2413 4.53713 59.0426 4.50558 58.8474 4.51609C58.7114 4.52311 58.5894 4.43545 58.565 4.30922L58.565 4.27065C58.5615 4.14092 58.6766 4.03573 58.823 4.02872C59.3215 4.00417 59.8061 4.16546 60.1896 4.48454L60.3639 4.6283L60.1443 4.61427L60.1443 4.61076Z" fill="url(#paint20_linear_409_2)"/>
    <path d="M58.6348 4.29521C58.6522 4.38988 58.7463 4.45299 58.8474 4.44598C59.0566 4.43546 59.2658 4.47052 59.461 4.54065C59.6911 4.51961 59.9247 4.51961 60.1548 4.54065C60.1548 4.54065 60.1548 4.53714 60.1513 4.53364C59.7817 4.22859 59.3111 4.0708 58.8335 4.09535C58.708 4.10236 58.6208 4.19703 58.6417 4.2917L58.6348 4.29521Z" fill="#F7941E"/>
    <path d="M60.1966 25.9536C59.7956 26.2832 59.318 26.441 58.823 26.4165C58.6766 26.4095 58.5615 26.3043 58.5615 26.1745L58.5615 26.136C58.5894 26.0097 58.7114 25.9186 58.8474 25.9256C59.0426 25.9361 59.2378 25.9045 59.4331 25.8344C59.6876 25.8519 59.9177 25.8519 60.1443 25.8309L60.3674 25.8099L60.1966 25.9536Z" fill="url(#paint21_linear_409_2)"/>
    <path d="M58.6348 26.1501C58.6522 26.0554 58.7463 25.9923 58.8474 25.9993C59.0566 26.0098 59.2658 25.9748 59.461 25.9046C59.6911 25.9257 59.9247 25.9257 60.1548 25.9046C60.1548 25.9046 60.1548 25.9081 60.1513 25.9116C59.7817 26.2167 59.3111 26.3745 58.8335 26.3499C58.708 26.3429 58.6208 26.2482 58.6417 26.1536L58.6348 26.1501Z" fill="#F7941E"/>
    <path d="M61.9118 10.6767C61.9118 10.596 61.9048 10.5189 61.9013 10.4417L62.4766 10.5259C62.7764 10.5259 63.0169 12.6086 63.0169 15.1788C63.0169 17.7489 62.7764 19.8316 62.4766 19.8316L61.8142 19.9298C61.8107 19.8912 61.8037 19.8562 61.7968 19.8176C62.0791 19.6563 62.3023 17.6437 62.3023 15.1823C62.3023 13.0574 62.1384 11.2692 61.9118 10.7117C61.9118 10.7012 61.9118 10.6907 61.9118 10.6802L61.9118 10.6767Z" fill="url(#paint22_linear_409_2)"/>
    <path d="M44.9722 24.8246L47.6077 26.7566L50.7244 26.7426L51.5367 24.225L45.0419 24.7405L44.9722 24.8246Z" fill="url(#paint23_linear_409_2)"/>
    <path d="M44.9722 5.52588L47.6077 3.59391L50.7244 3.60793L51.5367 6.09741L45.0419 5.61004L44.9722 5.52588Z" fill="url(#paint24_linear_409_2)"/>
    <path d="M44.9722 6.00276L44.9722 6.02731C45.3103 8.25732 45.5021 11.5918 45.5021 15.1823C45.5021 18.7727 45.3103 22.1072 44.9757 24.3373L44.9757 24.3618L44.9757 24.8036L50.7035 25.1858C52.4501 25.1858 52.471 15.5925 52.471 15.1858C52.471 14.7791 52.4501 5.18229 50.7279 5.18229L44.9757 5.56447L44.9757 6.00627L44.9722 6.00276Z" fill="black"/>
    <path d="M52.1189 15.1787C52.1189 20.319 51.4949 24.8491 50.7244 24.8491L45.3208 24.488L45.3208 24.3793C45.6415 22.2299 45.8507 18.9094 45.8507 15.1787C45.8507 11.448 45.645 8.12752 45.3208 5.97815L45.3208 5.86946L50.7244 5.50831C51.4949 5.50831 52.1189 10.0385 52.1189 15.1787Z" fill="url(#paint25_linear_409_2)"/>
    <path d="M27.5794 4.67387L30.853 6.54624L30.853 23.8183L27.6213 25.7188C26.9693 25.4312 26.4534 20.8239 26.4534 15.1823C26.4534 9.54063 26.9484 5.14722 27.5759 4.67387L27.5794 4.67387Z" fill="url(#paint26_linear_409_2)"/>
    <path d="M50.2538 3.98307C50.2538 3.98307 49.9819 2.95572 49.0964 2.99078C48.2074 3.02585 46.4817 4.20397 47.6182 4.15488C48.7582 4.10579 49.9191 4.10229 50.2538 3.98307Z" fill="url(#paint27_linear_409_2)"/>
    <path d="M48.2875 0.294428C48.8488 0.31196 49.567 3.01533 49.3717 3.09247C49.3787 3.68153 48.9464 3.75165 48.6431 3.69555C48.7756 2.41925 48.4235 1.24464 47.7925 0.375075C47.911 0.29443 48.0853 0.210276 48.2875 0.290921L48.2875 0.294428Z" fill="url(#paint28_linear_409_2)"/>
    <path d="M48.6397 3.76221C48.434 3.73065 48.2737 3.66052 48.2702 3.66052C48.4375 2.46487 48.1621 1.33233 47.6078 0.455755C47.6078 0.455755 47.6705 0.382124 47.7716 0.311998C48.4201 1.22364 48.7826 2.44033 48.6397 3.76221Z" fill="url(#paint29_linear_409_2)"/>
    <path d="M50.2538 26.2798C50.2538 26.2798 49.9819 27.3071 49.0964 27.2721C48.2074 27.237 46.4817 26.0589 47.6182 26.108C48.7582 26.1571 49.9191 26.1606 50.2538 26.2798Z" fill="url(#paint30_linear_409_2)"/>
    <path d="M48.2875 29.9684C48.8488 29.9509 49.567 27.2475 49.3717 27.1704C49.3787 26.5848 48.9464 26.5112 48.6431 26.5673C48.7756 27.8436 48.4235 29.0182 47.7925 29.8878C47.911 29.9684 48.0853 30.0491 48.2875 29.9684Z" fill="url(#paint31_linear_409_2)"/>
    <path d="M48.6397 26.5007C48.434 26.5323 48.2737 26.6024 48.2702 26.6024C48.4375 27.7981 48.1621 28.9306 47.6078 29.8072C47.6078 29.8072 47.6705 29.8808 47.7716 29.9509C48.4201 29.0428 48.7826 27.8226 48.6397 26.5007Z" fill="url(#paint32_linear_409_2)"/>
    <path d="M44.9722 24.7791L31.0133 23.7727C30.9611 23.8008 30.9088 23.8148 30.853 23.8148C29.9884 23.8148 29.2842 20.312 29.2842 15.1788C29.2842 10.0455 29.9884 6.54273 30.853 6.54273L44.9722 5.5259L44.9722 24.7791Z" fill="url(#paint33_linear_409_2)"/>
    <path style="mix-blend-mode:multiply" d="M59.9665 4.64228C60.214 4.75799 61.3331 6.33933 61.7549 6.93541C61.856 7.07917 61.9432 7.20189 62.0025 7.28253C62.3127 7.71381 62.5846 7.78043 62.7555 7.7629C62.9089 7.74537 63.0344 7.64719 63.0936 7.50343C63.1215 7.43681 63.1355 7.36668 63.1355 7.28604C63.1355 7.21241 63.125 7.13527 63.1006 7.06163C62.2848 4.38281 60.0606 4.30567 60.0362 4.30567L59.963 4.64228L59.9665 4.64228Z" fill="url(#paint34_linear_409_2)"/>
    <path d="M62.9333 7.43333C62.8461 7.64371 62.5254 7.71033 62.1419 7.17737C61.7584 6.64791 60.3674 4.62126 60.0327 4.47751C60.0327 4.47751 62.1454 4.52309 62.9333 7.11075C62.9646 7.20892 62.9751 7.33164 62.9333 7.43333Z" fill="url(#paint35_linear_409_2)"/>
    <path d="M61.8944 6.07291C62.3999 6.73209 62.6962 7.36323 62.6195 7.57361C62.487 7.53855 62.3197 7.42634 62.1419 7.1774C61.8734 6.80573 61.11 5.70124 60.5626 5.02452C60.5696 5.01751 60.5696 5.00348 60.5766 4.99997C60.7474 4.86673 61.34 5.3471 61.8944 6.07291Z" fill="#FBEA00"/>
    <path style="mix-blend-mode:multiply" d="M59.9665 25.7363C60.214 25.6206 61.3331 24.0392 61.7549 23.4431C61.856 23.2994 61.9432 23.1767 62.0025 23.096C62.3127 22.6647 62.5846 22.5981 62.7555 22.6157C62.9089 22.6332 63.0344 22.7279 63.0936 22.8751C63.1215 22.9417 63.1355 23.0154 63.1355 23.0925C63.1355 23.1661 63.125 23.2433 63.1006 23.3169C62.2848 25.9957 60.0606 26.0729 60.0362 26.0729L59.963 25.7363L59.9665 25.7363Z" fill="url(#paint36_linear_409_2)"/>
    <path d="M62.9333 22.9418C62.8461 22.7314 62.5254 22.6683 62.1419 23.1977C61.7584 23.7272 60.3674 25.7538 60.0327 25.8976C60.0327 25.8976 62.1454 25.852 62.9333 23.2643C62.9646 23.1662 62.9751 23.0434 62.9333 22.9418Z" fill="url(#paint37_linear_409_2)"/>
    <path d="M61.8944 24.3022C62.3999 23.643 62.6962 23.0119 62.6195 22.8015C62.487 22.8366 62.3197 22.9488 62.1419 23.1977C61.8734 23.5694 61.11 24.6739 60.5626 25.3506C60.5696 25.3576 60.5696 25.3716 60.5766 25.3751C60.7474 25.5084 61.34 25.028 61.8944 24.2987L61.8944 24.3022Z" fill="#FBEA00"/>
    <path style="mix-blend-mode:screen" d="M52.119 15.1787C52.119 15.8765 52.1085 16.5637 52.0841 17.2299C50.5258 19.3758 48.2493 20.88 45.6416 21.3113C45.7741 19.5266 45.8473 17.4298 45.8473 15.1787C45.8473 11.448 45.6416 8.12755 45.3174 5.97818L45.3174 5.86948L50.721 5.50833C51.4915 5.50833 52.1155 10.0385 52.1155 15.1787L52.119 15.1787Z" fill="url(#paint38_linear_409_2)"/>
    <path d="M44.3586 4.26711L43.6265 5.17525L35.1097 6.05884L33.9279 4.49502L44.3586 4.26711Z" fill="url(#paint39_linear_409_2)"/>
    <path style="mix-blend-mode:screen" d="M40.6319 4.32321L39.3838 5.17525L35.1097 6.05884L33.9279 4.49502L40.6319 4.32321Z" fill="url(#paint40_linear_409_2)"/>
    <path d="M44.2052 26.1079L43.6265 25.1822L35.1097 24.3022L33.9279 25.866L44.2052 26.1079Z" fill="url(#paint41_linear_409_2)"/>
    <path style="mix-blend-mode:screen" d="M40.1298 25.9677L39.3838 25.1822L35.1097 24.3022L33.9279 25.866L40.1298 25.9677Z" fill="url(#paint42_linear_409_2)"/>
    <path d="M34.4821 6.05884L31.4805 6.05884L29.8768 4.58268L33.4642 4.50203L34.4821 6.05884Z" fill="url(#paint43_linear_409_2)"/>
    <path d="M34.4821 24.3793L31.4805 24.3793L29.8768 25.7678L33.4188 25.8555L34.4821 24.3793Z" fill="url(#paint44_linear_409_2)"/>
    <path style="mix-blend-mode:overlay" d="M43.393 20.7012C43.5255 20.7012 43.6335 20.8099 43.6335 20.9431C43.6335 21.0764 43.5255 21.1851 43.393 21.1851L31.1668 21.1851C31.0343 21.1851 30.9263 21.0764 30.9263 20.9431C30.9263 20.8099 31.0343 20.7012 31.1668 20.7012L43.393 20.7012ZM31.1668 19.5441C31.0343 19.5441 30.9263 19.6528 30.9263 19.786C30.9263 19.9193 31.0343 20.028 31.1668 20.028L43.393 20.028C43.5255 20.028 43.6335 19.9193 43.6335 19.786C43.6335 19.6528 43.5255 19.5441 43.393 19.5441L31.1668 19.5441ZM31.1668 18.387C31.0343 18.387 30.9263 18.4957 30.9263 18.629C30.9263 18.7622 31.0343 18.8709 31.1668 18.8709L43.393 18.8709C43.5255 18.8709 43.6335 18.7622 43.6335 18.629C43.6335 18.4957 43.5255 18.387 43.393 18.387L31.1668 18.387ZM31.1668 17.2299C31.0343 17.2299 30.9263 17.3386 30.9263 17.4719C30.9263 17.6051 31.0343 17.7138 31.1668 17.7138L43.393 17.7138C43.5255 17.7138 43.6335 17.6051 43.6335 17.4719C43.6335 17.3386 43.5255 17.2299 43.393 17.2299L31.1668 17.2299ZM31.1668 16.0729C31.0343 16.0729 30.9263 16.1816 30.9263 16.3148C30.9263 16.448 31.0343 16.5567 31.1668 16.5567L43.393 16.5567C43.5255 16.5567 43.6335 16.448 43.6335 16.3148C43.6335 16.1816 43.5255 16.0729 43.393 16.0729L31.1668 16.0729ZM31.1668 14.9158C31.0343 14.9158 30.9263 15.0245 30.9263 15.1577C30.9263 15.2909 31.0343 15.3996 31.1668 15.3996L43.393 15.3996C43.5255 15.3996 43.6335 15.2909 43.6335 15.1577C43.6335 15.0245 43.5255 14.9158 43.393 14.9158L31.1668 14.9158ZM31.1668 13.7587C31.0343 13.7587 30.9263 13.8674 30.9263 14.0006C30.9263 14.1339 31.0343 14.2426 31.1668 14.2426L43.393 14.2426C43.5255 14.2426 43.6335 14.1339 43.6335 14.0006C43.6335 13.8674 43.5255 13.7587 43.393 13.7587L31.1668 13.7587ZM31.1668 12.6016C31.0343 12.6016 30.9263 12.7103 30.9263 12.8435C30.9263 12.9768 31.0343 13.0855 31.1668 13.0855L43.393 13.0855C43.5255 13.0855 43.6335 12.9768 43.6335 12.8435C43.6335 12.7103 43.5255 12.6016 43.393 12.6016L31.1668 12.6016ZM31.1668 11.4445C31.0343 11.4445 30.9263 11.5532 30.9263 11.6865C30.9263 11.8197 31.0343 11.9284 31.1668 11.9284L43.393 11.9284C43.5255 11.9284 43.6335 11.8197 43.6335 11.6865C43.6335 11.5532 43.5255 11.4445 43.393 11.4445L31.1668 11.4445ZM31.1668 10.2874C31.0343 10.2874 30.9263 10.3961 30.9263 10.5294C30.9263 10.6626 31.0343 10.7713 31.1668 10.7713L43.393 10.7713C43.5255 10.7713 43.6335 10.6626 43.6335 10.5294C43.6335 10.3961 43.5255 10.2874 43.393 10.2874L31.1668 10.2874ZM31.1668 9.13036C31.0343 9.13036 30.9263 9.23905 30.9263 9.37229C30.9263 9.50553 31.0343 9.61423 31.1668 9.61423L43.393 9.61423C43.5255 9.61423 43.6335 9.50553 43.6335 9.37229C43.6335 9.23905 43.5255 9.13036 43.393 9.13036L31.1668 9.13036Z" fill="url(#paint45_linear_409_2)"/>
    <path style="mix-blend-mode:screen" d="M44.8223 15.1542C44.8223 19.8457 44.4214 23.65 43.9263 23.65L31.1772 22.7314C30.8426 21.995 30.3301 19.6178 30.3301 15.1823C30.3301 10.7468 30.8704 8.23628 31.2051 7.57359L43.9263 6.65844C44.4214 6.65844 44.8223 10.4628 44.8223 15.1542Z" fill="url(#paint46_linear_409_2)"/>
    <path d="M7.82727e-08 11.9109L0 18.4747L1.04587 18.4747L1.04587 11.9109L7.82727e-08 11.9109Z" fill="url(#paint47_linear_409_2)"/>
    <path d="M4.41016 10.7959L4.41016 8.36252L6.37987 8.2959L6.37987 10.7258L4.41016 10.7959Z" fill="black"/>
    <path d="M1.91748 6.4201L1.91748 6.61646L8.7923 6.61646L8.7923 6.4201L1.91748 6.4201Z" fill="black"/>
    <path d="M9.48953 4.32323L9.48953 5.83445C9.48953 6.17106 9.17926 6.44104 8.79229 6.44104L2.09177 6.44104C1.70829 6.44104 1.39453 6.16755 1.39453 5.83445L1.39453 4.32323C1.39453 3.99013 1.70829 3.71664 2.09177 3.71664L8.79229 3.71664C9.17926 3.71664 9.48953 3.99013 9.48953 4.32323Z" fill="url(#paint48_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 6.44104L8.79236 5.74679L9.263 5.74679L9.263 6.27975C9.13749 6.37793 8.97364 6.44104 8.79236 6.44104Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 5.7468L7.66626 6.51819L8.1369 6.51819L8.1369 5.7468L7.66626 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 5.7468L6.53674 6.51819L7.00738 6.51819L7.00738 5.7468L6.53674 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 5.7468L5.40723 6.51819L5.87787 6.51819L5.87787 5.7468L5.40723 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 5.7468L4.27771 6.51819L4.74835 6.51819L4.74835 5.7468L4.27771 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 5.7468L3.15161 6.51819L3.62225 6.51819L3.62225 5.7468L3.15161 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 5.7468L2.02209 6.51819L2.49273 6.51819L2.49273 5.7468L2.02209 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M9.263 4.48804L8.79236 4.48804L8.79236 3.71665C8.97364 3.71665 9.13749 3.77976 9.263 3.87794L9.263 4.48804Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 3.71665L7.66626 4.48804L8.1369 4.48804L8.1369 3.71665L7.66626 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 3.71665L6.53674 4.48804L7.00738 4.48804L7.00738 3.71665L6.53674 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 3.71665L5.40723 4.48804L5.87787 4.48804L5.87787 3.71665L5.40723 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 3.71665L4.27771 4.48804L4.74835 4.48804L4.74835 3.71665L4.27771 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 3.71665L3.15161 4.48804L3.62225 4.48804L3.62225 3.71665L3.15161 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 3.71665L2.02209 4.48804L2.49273 4.48804L2.49273 3.71665L2.02209 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 4.69138L8.16479 5.46277L8.63543 5.46277L8.63543 4.69138L8.16479 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 4.69138L7.0387 5.46277L7.50934 5.46277L7.50934 4.69138L7.0387 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 4.69138L5.90918 5.46277L6.37982 5.46277L6.37982 4.69138L5.90918 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 4.69138L4.77966 5.46277L5.2503 5.46277L5.2503 4.69138L4.77966 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 4.69138L3.65015 5.46277L4.12079 5.46277L4.12079 4.69138L3.65015 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 4.69138L2.52405 5.46277L2.99469 5.46277L2.99469 4.69138L2.52405 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 4.69138L8.79236 5.46277L9.263 5.46277L9.263 4.69138L8.79236 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 4.69138L7.66626 5.46277L8.1369 5.46277L8.1369 4.69138L7.66626 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 4.69138L6.53674 5.46277L7.00738 5.46277L7.00738 4.69138L6.53674 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 4.69138L5.40723 5.46277L5.87787 5.46277L5.87787 4.69138L5.40723 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 4.69138L4.27771 5.46277L4.74835 5.46277L4.74835 4.69138L4.27771 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 4.69138L3.15161 5.46277L3.62225 5.46277L3.62225 4.69138L3.15161 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 4.69138L2.02209 5.46277L2.49273 5.46277L2.49273 4.69138L2.02209 4.69138Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 3.71665L8.16479 4.48804L8.63543 4.48804L8.63543 3.71665L8.16479 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 3.71665L7.0387 4.48804L7.50934 4.48804L7.50934 3.71665L7.0387 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 3.71665L5.90918 4.48804L6.37982 4.48804L6.37982 3.71665L5.90918 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 3.71665L4.77966 4.48804L5.2503 4.48804L5.2503 3.71665L4.77966 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 3.71665L3.65015 4.48804L4.12079 4.48804L4.12079 3.71665L3.65015 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 3.71665L2.52405 4.48804L2.99469 4.48804L2.99469 3.71665L2.52405 3.71665Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 5.7468L8.16479 6.51819L8.63543 6.51819L8.63543 5.7468L8.16479 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 5.7468L7.0387 6.51819L7.50934 6.51819L7.50934 5.7468L7.0387 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 5.7468L5.90918 6.51819L6.37982 6.51819L6.37982 5.7468L5.90918 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 5.7468L4.77966 6.51819L5.2503 6.51819L5.2503 5.7468L4.77966 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 5.7468L3.65015 6.51819L4.12079 6.51819L4.12079 5.7468L3.65015 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 5.7468L2.52405 6.51819L2.99469 6.51819L2.99469 5.7468L2.52405 5.7468Z" fill="#636363"/>
    </g>
    </g>
    <path d="M9.48953 7.22301L9.48953 8.73423C9.48953 9.07083 9.17926 9.34082 8.79229 9.34082L2.09177 9.34082C1.70829 9.34082 1.39453 9.06733 1.39453 8.73423L1.39453 7.22301C1.39453 6.8864 1.70829 6.61641 2.09177 6.61641L8.79229 6.61641C9.17926 6.61641 9.48953 6.88991 9.48953 7.22301Z" fill="url(#paint49_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 9.34082L8.79236 8.64657L9.263 8.64657L9.263 9.17953C9.13749 9.27771 8.97364 9.34082 8.79236 9.34082Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 8.64664L7.66626 9.3479L8.1369 9.3479L8.1369 8.64664L7.66626 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 8.64664L6.53674 9.3479L7.00738 9.3479L7.00738 8.64664L6.53674 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 8.64658L5.40723 9.41797L5.87787 9.41797L5.87787 8.64658L5.40723 8.64658Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 8.64657L4.27771 9.34082L4.74835 9.34082L4.74835 8.64657L4.27771 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 8.64657L3.15161 9.34082L3.62225 9.34082L3.62225 8.64657L3.15161 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 8.64657L2.02209 9.34082L2.49273 9.34082L2.49273 8.64657L2.02209 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M9.263 7.38782L8.79236 7.38782L8.79236 6.61643C8.97364 6.61643 9.13749 6.67954 9.263 6.77772L9.263 7.38782Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 6.61643L7.66626 7.38782L8.1369 7.38782L8.1369 6.61643L7.66626 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 6.61643L6.53674 7.38782L7.00738 7.38782L7.00738 6.61643L6.53674 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 6.61643L5.40723 7.38782L5.87787 7.38782L5.87787 6.61643L5.40723 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 6.61643L4.27771 7.38782L4.74835 7.38782L4.74835 6.61643L4.27771 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 6.61643L3.15161 7.38782L3.62225 7.38782L3.62225 6.61643L3.15161 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 6.61643L2.02209 7.38782L2.49273 7.38782L2.49273 6.61643L2.02209 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 7.59116L8.16479 8.36255L8.63543 8.36255L8.63543 7.59116L8.16479 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 7.59116L7.0387 8.36255L7.50934 8.36255L7.50934 7.59116L7.0387 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 7.59116L5.90918 8.36255L6.37982 8.36255L6.37982 7.59116L5.90918 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 7.59116L4.77966 8.36255L5.2503 8.36255L5.2503 7.59116L4.77966 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 7.59116L3.65015 8.36255L4.12079 8.36255L4.12079 7.59116L3.65015 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 7.59116L2.52405 8.36255L2.99469 8.36255L2.99469 7.59116L2.52405 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 7.59116L8.79236 8.36255L9.263 8.36255L9.263 7.59116L8.79236 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 7.59116L7.66626 8.36255L8.1369 8.36255L8.1369 7.59116L7.66626 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 7.59116L6.53674 8.36255L7.00738 8.36255L7.00738 7.59116L6.53674 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 7.59116L5.40723 8.36255L5.87787 8.36255L5.87787 7.59116L5.40723 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 7.59116L4.27771 8.36255L4.74835 8.36255L4.74835 7.59116L4.27771 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 7.59116L3.15161 8.36255L3.62225 8.36255L3.62225 7.59116L3.15161 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 7.59116L2.02209 8.36255L2.49273 8.36255L2.49273 7.59116L2.02209 7.59116Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 6.61643L8.16479 7.38782L8.63543 7.38782L8.63543 6.61643L8.16479 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 6.61643L7.0387 7.38782L7.50934 7.38782L7.50934 6.61643L7.0387 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 6.61643L5.90918 7.38782L6.37982 7.38782L6.37982 6.61643L5.90918 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 6.61643L4.77966 7.38782L5.2503 7.38782L5.2503 6.61643L4.77966 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 6.61643L3.65015 7.38782L4.12079 7.38782L4.12079 6.61643L3.65015 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 6.61643L2.52405 7.38782L2.99469 7.38782L2.99469 6.61643L2.52405 6.61643Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 8.64664L8.16479 9.3479L8.63543 9.3479L8.63543 8.64664L8.16479 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 8.64664L7.0387 9.3479L7.50934 9.3479L7.50934 8.64664L7.0387 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 8.64664L5.90918 9.3479L6.37982 9.3479L6.37982 8.64664L5.90918 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 8.64658L4.77966 9.41797L5.2503 9.41797L5.2503 8.64658L4.77966 8.64658Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 8.64657L3.65015 9.34082L4.12079 9.34082L4.12079 8.64657L3.65015 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 8.64657L2.52405 9.34082L2.99469 9.34082L2.99469 8.64657L2.52405 8.64657Z" fill="#636363"/>
    </g>
    </g>
    <path d="M16.2737 10.7959L16.2737 8.36252L18.2434 8.2959L18.2434 10.7258L16.2737 10.7959Z" fill="black"/>
    <path d="M13.7845 6.4201L13.7845 6.61646L20.6594 6.61646L20.6594 6.4201L13.7845 6.4201Z" fill="black"/>
    <path d="M21.3566 4.32323L21.3566 5.83445C21.3566 6.17106 21.0463 6.44104 20.6594 6.44104L13.9588 6.44104C13.5754 6.44104 13.2616 6.16755 13.2616 5.83445L13.2616 4.32323C13.2616 3.99013 13.5754 3.71664 13.9588 3.71664L20.6594 3.71664C21.0463 3.71664 21.3566 3.99013 21.3566 4.32323Z" fill="url(#paint50_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M20.6593 6.44104L20.6593 5.74679L21.1299 5.74679L21.1299 6.27975C21.0044 6.37793 20.8406 6.44104 20.6593 6.44104Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 5.7468L19.5298 6.51819L20.0004 6.51819L20.0004 5.7468L19.5298 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 5.7468L18.4003 6.51819L18.8709 6.51819L18.8709 5.7468L18.4003 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 5.7468L17.2742 6.51819L17.7448 6.51819L17.7448 5.7468L17.2742 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 5.7468L16.1447 6.51819L16.6153 6.51819L16.6153 5.7468L16.1447 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 5.7468L15.0151 6.51819L15.4858 6.51819L15.4858 5.7468L15.0151 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 5.7468L13.8856 6.51819L14.3563 6.51819L14.3563 5.7468L13.8856 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M21.1299 4.48804L20.6593 4.48804L20.6593 3.71665C20.8406 3.71665 21.0044 3.77976 21.1299 3.87794L21.1299 4.48804Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 3.71665L19.5298 4.48804L20.0004 4.48804L20.0004 3.71665L19.5298 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 3.71665L18.4003 4.48804L18.8709 4.48804L18.8709 3.71665L18.4003 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 3.71665L17.2742 4.48804L17.7448 4.48804L17.7448 3.71665L17.2742 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 3.71665L16.1447 4.48804L16.6153 4.48804L16.6153 3.71665L16.1447 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 3.71665L15.0151 4.48804L15.4858 4.48804L15.4858 3.71665L15.0151 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 3.71665L13.8856 4.48804L14.3563 4.48804L14.3563 3.71665L13.8856 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 4.69138L20.0319 5.46277L20.5025 5.46277L20.5025 4.69138L20.0319 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 4.69138L18.9023 5.46277L19.373 5.46277L19.373 4.69138L18.9023 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 4.69138L17.7728 5.46277L18.2435 5.46277L18.2435 4.69138L17.7728 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 4.69138L16.6467 5.46277L17.1174 5.46277L17.1174 4.69138L16.6467 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 4.69138L15.5172 5.46277L15.9879 5.46277L15.9879 4.69138L15.5172 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 4.69138L14.3877 5.46277L14.8583 5.46277L14.8583 4.69138L14.3877 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.6593 4.69138L20.6593 5.46277L21.1299 5.46277L21.1299 4.69138L20.6593 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 4.69138L19.5298 5.46277L20.0004 5.46277L20.0004 4.69138L19.5298 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 4.69138L18.4003 5.46277L18.8709 5.46277L18.8709 4.69138L18.4003 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 4.69138L17.2742 5.46277L17.7448 5.46277L17.7448 4.69138L17.2742 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 4.69138L16.1447 5.46277L16.6153 5.46277L16.6153 4.69138L16.1447 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 4.69138L15.0151 5.46277L15.4858 5.46277L15.4858 4.69138L15.0151 4.69138Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 4.69138L13.8856 5.46277L14.3563 5.46277L14.3563 4.69138L13.8856 4.69138Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 3.71665L20.0319 4.48804L20.5025 4.48804L20.5025 3.71665L20.0319 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 3.71665L18.9023 4.48804L19.373 4.48804L19.373 3.71665L18.9023 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 3.71665L17.7728 4.48804L18.2435 4.48804L18.2435 3.71665L17.7728 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 3.71665L16.6467 4.48804L17.1174 4.48804L17.1174 3.71665L16.6467 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 3.71665L15.5172 4.48804L15.9879 4.48804L15.9879 3.71665L15.5172 3.71665Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 3.71665L14.3877 4.48804L14.8583 4.48804L14.8583 3.71665L14.3877 3.71665Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 5.7468L20.0319 6.51819L20.5025 6.51819L20.5025 5.7468L20.0319 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 5.7468L18.9023 6.51819L19.373 6.51819L19.373 5.7468L18.9023 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 5.7468L17.7728 6.51819L18.2435 6.51819L18.2435 5.7468L17.7728 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 5.7468L16.6467 6.51819L17.1174 6.51819L17.1174 5.7468L16.6467 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 5.7468L15.5172 6.51819L15.9879 6.51819L15.9879 5.7468L15.5172 5.7468Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 5.7468L14.3877 6.51819L14.8583 6.51819L14.8583 5.7468L14.3877 5.7468Z" fill="#636363"/>
    </g>
    </g>
    <path d="M21.3566 7.22301L21.3566 8.73423C21.3566 9.07083 21.0463 9.34082 20.6594 9.34082L13.9588 9.34082C13.5754 9.34082 13.2616 9.06733 13.2616 8.73423L13.2616 7.22301C13.2616 6.8864 13.5754 6.61641 13.9588 6.61641L20.6594 6.61641C21.0463 6.61641 21.3566 6.88991 21.3566 7.22301Z" fill="url(#paint51_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M20.6593 9.34082L20.6593 8.64657L21.1299 8.64657L21.1299 9.17953C21.0044 9.27771 20.8406 9.34082 20.6593 9.34082Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 8.64664L19.5298 9.3479L20.0004 9.3479L20.0004 8.64664L19.5298 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 8.64664L18.4003 9.3479L18.8709 9.3479L18.8709 8.64664L18.4003 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 8.64658L17.2742 9.41797L17.7448 9.41797L17.7448 8.64658L17.2742 8.64658Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 8.64657L16.1447 9.34082L16.6153 9.34082L16.6153 8.64657L16.1447 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 8.64657L15.0151 9.34082L15.4858 9.34082L15.4858 8.64657L15.0151 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 8.64657L13.8856 9.34082L14.3563 9.34082L14.3563 8.64657L13.8856 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M21.1299 7.38782L20.6593 7.38782L20.6593 6.61643C20.8406 6.61643 21.0044 6.67954 21.1299 6.77772L21.1299 7.38782Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 6.61643L19.5298 7.38782L20.0004 7.38782L20.0004 6.61643L19.5298 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 6.61643L18.4003 7.38782L18.8709 7.38782L18.8709 6.61643L18.4003 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 6.61643L17.2742 7.38782L17.7448 7.38782L17.7448 6.61643L17.2742 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 6.61643L16.1447 7.38782L16.6153 7.38782L16.6153 6.61643L16.1447 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 6.61643L15.0151 7.38782L15.4858 7.38782L15.4858 6.61643L15.0151 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 6.61643L13.8856 7.38782L14.3563 7.38782L14.3563 6.61643L13.8856 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 7.59116L20.0319 8.36255L20.5025 8.36255L20.5025 7.59116L20.0319 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 7.59116L18.9023 8.36255L19.373 8.36255L19.373 7.59116L18.9023 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 7.59116L17.7728 8.36255L18.2435 8.36255L18.2435 7.59116L17.7728 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 7.59116L16.6467 8.36255L17.1174 8.36255L17.1174 7.59116L16.6467 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 7.59116L15.5172 8.36255L15.9879 8.36255L15.9879 7.59116L15.5172 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 7.59116L14.3877 8.36255L14.8583 8.36255L14.8583 7.59116L14.3877 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.6593 7.59116L20.6593 8.36255L21.1299 8.36255L21.1299 7.59116L20.6593 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.5298 7.59116L19.5298 8.36255L20.0004 8.36255L20.0004 7.59116L19.5298 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.4003 7.59116L18.4003 8.36255L18.8709 8.36255L18.8709 7.59116L18.4003 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.2742 7.59116L17.2742 8.36255L17.7448 8.36255L17.7448 7.59116L17.2742 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.1447 7.59116L16.1447 8.36255L16.6153 8.36255L16.6153 7.59116L16.1447 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.0151 7.59116L15.0151 8.36255L15.4858 8.36255L15.4858 7.59116L15.0151 7.59116Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.8856 7.59116L13.8856 8.36255L14.3563 8.36255L14.3563 7.59116L13.8856 7.59116Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 6.61643L20.0319 7.38782L20.5025 7.38782L20.5025 6.61643L20.0319 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 6.61643L18.9023 7.38782L19.373 7.38782L19.373 6.61643L18.9023 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 6.61643L17.7728 7.38782L18.2435 7.38782L18.2435 6.61643L17.7728 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 6.61643L16.6467 7.38782L17.1174 7.38782L17.1174 6.61643L16.6467 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 6.61643L15.5172 7.38782L15.9879 7.38782L15.9879 6.61643L15.5172 6.61643Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 6.61643L14.3877 7.38782L14.8583 7.38782L14.8583 6.61643L14.3877 6.61643Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.0319 8.64664L20.0319 9.3479L20.5025 9.3479L20.5025 8.64664L20.0319 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.9023 8.64664L18.9023 9.3479L19.373 9.3479L19.373 8.64664L18.9023 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.7728 8.64664L17.7728 9.3479L18.2435 9.3479L18.2435 8.64664L17.7728 8.64664Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.6467 8.64658L16.6467 9.41797L17.1174 9.41797L17.1174 8.64658L16.6467 8.64658Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.5172 8.64657L15.5172 9.34082L15.9879 9.34082L15.9879 8.64657L15.5172 8.64657Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.3877 8.64657L14.3877 9.34082L14.8583 9.34082L14.8583 8.64657L14.3877 8.64657Z" fill="#636363"/>
    </g>
    </g>
    <path d="M4.41016 19.5897L4.41016 22.0231L6.37987 22.0897L6.37987 19.6598L4.41016 19.5897Z" fill="black"/>
    <path d="M1.91748 23.7692L1.91748 23.9656L8.7923 23.9656L8.7923 23.7692L1.91748 23.7692Z" fill="black"/>
    <path d="M9.48953 26.0624L9.48953 24.5511C9.48953 24.218 9.17926 23.9445 8.79229 23.9445L2.09177 23.9445C1.70829 23.9445 1.39453 24.218 1.39453 24.5511L1.39453 26.0624C1.39453 26.3955 1.70829 26.6689 2.09177 26.6689L8.79229 26.6689C9.17926 26.6689 9.48953 26.3955 9.48953 26.0624Z" fill="url(#paint52_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 23.9445L8.79236 24.6388L9.263 24.6388L9.263 24.1058C9.13749 24.0077 8.97364 23.9445 8.79236 23.9445Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 23.8674L7.66626 24.6388L8.1369 24.6388L8.1369 23.8674L7.66626 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 23.8674L6.53674 24.6388L7.00738 24.6388L7.00738 23.8674L6.53674 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 23.8674L5.40723 24.6388L5.87787 24.6388L5.87787 23.8674L5.40723 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 23.8674L4.27771 24.6388L4.74835 24.6388L4.74835 23.8674L4.27771 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 23.8674L3.15161 24.6388L3.62225 24.6388L3.62225 23.8674L3.15161 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 23.8674L2.02209 24.6388L2.49273 24.6388L2.49273 23.8674L2.02209 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M9.263 25.8976L8.79236 25.8976L8.79236 26.6689C8.97364 26.6689 9.13749 26.6058 9.263 26.5077L9.263 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 25.8976L7.66626 26.6689L8.1369 26.6689L8.1369 25.8976L7.66626 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 25.8976L6.53674 26.6689L7.00738 26.6689L7.00738 25.8976L6.53674 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 25.8976L5.40723 26.6689L5.87787 26.6689L5.87787 25.8976L5.40723 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 25.8976L4.27771 26.6689L4.74835 26.6689L4.74835 25.8976L4.27771 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 25.8976L3.15161 26.6689L3.62225 26.6689L3.62225 25.8976L3.15161 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 25.8976L2.02209 26.6689L2.49273 26.6689L2.49273 25.8976L2.02209 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 24.9228L8.16479 25.6942L8.63543 25.6942L8.63543 24.9228L8.16479 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 24.9228L7.0387 25.6942L7.50934 25.6942L7.50934 24.9228L7.0387 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 24.9228L5.90918 25.6942L6.37982 25.6942L6.37982 24.9228L5.90918 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 24.9228L4.77966 25.6942L5.2503 25.6942L5.2503 24.9228L4.77966 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 24.9228L3.65015 25.6942L4.12079 25.6942L4.12079 24.9228L3.65015 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 24.9228L2.52405 25.6942L2.99469 25.6942L2.99469 24.9228L2.52405 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 24.9228L8.79236 25.6942L9.263 25.6942L9.263 24.9228L8.79236 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 24.9228L7.66626 25.6942L8.1369 25.6942L8.1369 24.9228L7.66626 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 24.9228L6.53674 25.6942L7.00738 25.6942L7.00738 24.9228L6.53674 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 24.9228L5.40723 25.6942L5.87787 25.6942L5.87787 24.9228L5.40723 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 24.9228L4.27771 25.6942L4.74835 25.6942L4.74835 24.9228L4.27771 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 24.9228L3.15161 25.6942L3.62225 25.6942L3.62225 24.9228L3.15161 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 24.9228L2.02209 25.6942L2.49273 25.6942L2.49273 24.9228L2.02209 24.9228Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 25.8976L8.16479 26.6689L8.63543 26.6689L8.63543 25.8976L8.16479 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 25.8976L7.0387 26.6689L7.50934 26.6689L7.50934 25.8976L7.0387 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 25.8976L5.90918 26.6689L6.37982 26.6689L6.37982 25.8976L5.90918 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 25.8976L4.77966 26.6689L5.2503 26.6689L5.2503 25.8976L4.77966 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 25.8976L3.65015 26.6689L4.12079 26.6689L4.12079 25.8976L3.65015 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 25.8976L2.52405 26.6689L2.99469 26.6689L2.99469 25.8976L2.52405 25.8976Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 23.8674L8.16479 24.6388L8.63543 24.6388L8.63543 23.8674L8.16479 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 23.8674L7.0387 24.6388L7.50934 24.6388L7.50934 23.8674L7.0387 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 23.8674L5.90918 24.6388L6.37982 24.6388L6.37982 23.8674L5.90918 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 23.8674L4.77966 24.6388L5.2503 24.6388L5.2503 23.8674L4.77966 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 23.8674L3.65015 24.6388L4.12079 24.6388L4.12079 23.8674L3.65015 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 23.8674L2.52405 24.6388L2.99469 24.6388L2.99469 23.8674L2.52405 23.8674Z" fill="#636363"/>
    </g>
    </g>
    <path d="M9.48953 23.1626L9.48953 21.6514C9.48953 21.3147 9.17926 21.0448 8.79229 21.0448L2.09177 21.0448C1.70829 21.0448 1.39453 21.3183 1.39453 21.6514L1.39453 23.1626C1.39453 23.4957 1.70829 23.7692 2.09177 23.7692L8.79229 23.7692C9.17926 23.7692 9.48953 23.4957 9.48953 23.1626Z" fill="url(#paint53_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 21.0448L8.79236 21.739L9.263 21.739L9.263 21.2061C9.13749 21.1079 8.97364 21.0448 8.79236 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 21.0378L7.66626 21.739L8.1369 21.739L8.1369 21.0378L7.66626 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 21.0378L6.53674 21.739L7.00738 21.739L7.00738 21.0378L6.53674 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 20.9676L5.40723 21.739L5.87787 21.739L5.87787 20.9676L5.40723 20.9676Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 21.0448L4.27771 21.739L4.74835 21.739L4.74835 21.0448L4.27771 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 21.0448L3.15161 21.739L3.62225 21.739L3.62225 21.0448L3.15161 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 21.0448L2.02209 21.739L2.49273 21.739L2.49273 21.0448L2.02209 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M9.263 22.9978L8.79236 22.9978L8.79236 23.7692C8.97364 23.7692 9.13749 23.7061 9.263 23.6079L9.263 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 22.9978L7.66626 23.7692L8.1369 23.7692L8.1369 22.9978L7.66626 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 22.9978L6.53674 23.7692L7.00738 23.7692L7.00738 22.9978L6.53674 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 22.9978L5.40723 23.7692L5.87787 23.7692L5.87787 22.9978L5.40723 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 22.9978L4.27771 23.7692L4.74835 23.7692L4.74835 22.9978L4.27771 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 22.9978L3.15161 23.7692L3.62225 23.7692L3.62225 22.9978L3.15161 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 22.9978L2.02209 23.7692L2.49273 23.7692L2.49273 22.9978L2.02209 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 22.0195L8.16479 22.7909L8.63543 22.7909L8.63543 22.0195L8.16479 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 22.0195L7.0387 22.7909L7.50934 22.7909L7.50934 22.0195L7.0387 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 22.0195L5.90918 22.7909L6.37982 22.7909L6.37982 22.0195L5.90918 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 22.0195L4.77966 22.7909L5.2503 22.7909L5.2503 22.0195L4.77966 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 22.0195L3.65015 22.7909L4.12079 22.7909L4.12079 22.0195L3.65015 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 22.0195L2.52405 22.7909L2.99469 22.7909L2.99469 22.0195L2.52405 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.79236 22.0195L8.79236 22.7909L9.263 22.7909L9.263 22.0195L8.79236 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.66626 22.0195L7.66626 22.7909L8.1369 22.7909L8.1369 22.0195L7.66626 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M6.53674 22.0195L6.53674 22.7909L7.00738 22.7909L7.00738 22.0195L6.53674 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.40723 22.0195L5.40723 22.7909L5.87787 22.7909L5.87787 22.0195L5.40723 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.27771 22.0195L4.27771 22.7909L4.74835 22.7909L4.74835 22.0195L4.27771 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.15161 22.0195L3.15161 22.7909L3.62225 22.7909L3.62225 22.0195L3.15161 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.02209 22.0195L2.02209 22.7909L2.49273 22.7909L2.49273 22.0195L2.02209 22.0195Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 22.9978L8.16479 23.7692L8.63543 23.7692L8.63543 22.9978L8.16479 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 22.9978L7.0387 23.7692L7.50934 23.7692L7.50934 22.9978L7.0387 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 22.9978L5.90918 23.7692L6.37982 23.7692L6.37982 22.9978L5.90918 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 22.9978L4.77966 23.7692L5.2503 23.7692L5.2503 22.9978L4.77966 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 22.9978L3.65015 23.7692L4.12079 23.7692L4.12079 22.9978L3.65015 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 22.9978L2.52405 23.7692L2.99469 23.7692L2.99469 22.9978L2.52405 22.9978Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M8.16479 21.0378L8.16479 21.739L8.63543 21.739L8.63543 21.0378L8.16479 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M7.0387 21.0378L7.0387 21.739L7.50934 21.739L7.50934 21.0378L7.0387 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M5.90918 21.0378L5.90918 21.739L6.37982 21.739L6.37982 21.0378L5.90918 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M4.77966 20.9676L4.77966 21.739L5.2503 21.739L5.2503 20.9676L4.77966 20.9676Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M3.65015 21.0448L3.65015 21.739L4.12079 21.739L4.12079 21.0448L3.65015 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M2.52405 21.0448L2.52405 21.739L2.99469 21.739L2.99469 21.0448L2.52405 21.0448Z" fill="#636363"/>
    </g>
    </g>
    <path d="M16.075 19.5897L16.075 22.0231L18.0447 22.0897L18.0447 19.6598L16.075 19.5897Z" fill="black"/>
    <path d="M13.5823 23.7692L13.5823 23.9656L20.4571 23.9656L20.4571 23.7692L13.5823 23.7692Z" fill="black"/>
    <path d="M21.1543 26.0624L21.1543 24.5511C21.1543 24.218 20.8441 23.9445 20.4571 23.9445L13.7566 23.9445C13.3731 23.9445 13.0593 24.218 13.0593 24.5511L13.0593 26.0624C13.0593 26.3955 13.3731 26.6689 13.7566 26.6689L20.4571 26.6689C20.8441 26.6689 21.1543 26.3955 21.1543 26.0624Z" fill="url(#paint54_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M20.4572 23.9445L20.4572 24.6388L20.9278 24.6388L20.9278 24.1058C20.8023 24.0077 20.6384 23.9445 20.4572 23.9445Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 23.8674L19.3311 24.6388L19.8017 24.6388L19.8017 23.8674L19.3311 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 23.8674L18.2015 24.6388L18.6722 24.6388L18.6722 23.8674L18.2015 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 23.8674L17.072 24.6388L17.5427 24.6388L17.5427 23.8674L17.072 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 23.8674L15.9425 24.6388L16.4131 24.6388L16.4131 23.8674L15.9425 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 23.8674L14.8164 24.6388L15.287 24.6388L15.287 23.8674L14.8164 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 23.8674L13.6869 24.6388L14.1575 24.6388L14.1575 23.8674L13.6869 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M20.9278 25.8976L20.4572 25.8976L20.4572 26.6689C20.6384 26.6689 20.8023 26.6058 20.9278 26.5077L20.9278 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 25.8976L19.3311 26.6689L19.8017 26.6689L19.8017 25.8976L19.3311 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 25.8976L18.2015 26.6689L18.6722 26.6689L18.6722 25.8976L18.2015 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 25.8976L17.072 26.6689L17.5427 26.6689L17.5427 25.8976L17.072 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 25.8976L15.9425 26.6689L16.4131 26.6689L16.4131 25.8976L15.9425 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 25.8976L14.8164 26.6689L15.287 26.6689L15.287 25.8976L14.8164 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 25.8976L13.6869 26.6689L14.1575 26.6689L14.1575 25.8976L13.6869 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 24.9228L19.8296 25.6942L20.3002 25.6942L20.3002 24.9228L19.8296 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 24.9228L18.7035 25.6942L19.1741 25.6942L19.1741 24.9228L18.7035 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 24.9228L17.574 25.6942L18.0446 25.6942L18.0446 24.9228L17.574 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 24.9228L16.4445 25.6942L16.9151 25.6942L16.9151 24.9228L16.4445 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 24.9228L15.3184 25.6942L15.789 25.6942L15.789 24.9228L15.3184 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 24.9228L14.1888 25.6942L14.6595 25.6942L14.6595 24.9228L14.1888 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.4572 24.9228L20.4572 25.6942L20.9278 25.6942L20.9278 24.9228L20.4572 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 24.9228L19.3311 25.6942L19.8017 25.6942L19.8017 24.9228L19.3311 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 24.9228L18.2015 25.6942L18.6722 25.6942L18.6722 24.9228L18.2015 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 24.9228L17.072 25.6942L17.5427 25.6942L17.5427 24.9228L17.072 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 24.9228L15.9425 25.6942L16.4131 25.6942L16.4131 24.9228L15.9425 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 24.9228L14.8164 25.6942L15.287 25.6942L15.287 24.9228L14.8164 24.9228Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 24.9228L13.6869 25.6942L14.1575 25.6942L14.1575 24.9228L13.6869 24.9228Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 25.8976L19.8296 26.6689L20.3002 26.6689L20.3002 25.8976L19.8296 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 25.8976L18.7035 26.6689L19.1741 26.6689L19.1741 25.8976L18.7035 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 25.8976L17.574 26.6689L18.0446 26.6689L18.0446 25.8976L17.574 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 25.8976L16.4445 26.6689L16.9151 26.6689L16.9151 25.8976L16.4445 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 25.8976L15.3184 26.6689L15.789 26.6689L15.789 25.8976L15.3184 25.8976Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 25.8976L14.1888 26.6689L14.6595 26.6689L14.6595 25.8976L14.1888 25.8976Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 23.8674L19.8296 24.6388L20.3002 24.6388L20.3002 23.8674L19.8296 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 23.8674L18.7035 24.6388L19.1741 24.6388L19.1741 23.8674L18.7035 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 23.8674L17.574 24.6388L18.0446 24.6388L18.0446 23.8674L17.574 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 23.8674L16.4445 24.6388L16.9151 24.6388L16.9151 23.8674L16.4445 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 23.8674L15.3184 24.6388L15.789 24.6388L15.789 23.8674L15.3184 23.8674Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 23.8674L14.1888 24.6388L14.6595 24.6388L14.6595 23.8674L14.1888 23.8674Z" fill="#636363"/>
    </g>
    </g>
    <path d="M21.1543 23.1626L21.1543 21.6514C21.1543 21.3147 20.8441 21.0448 20.4571 21.0448L13.7566 21.0448C13.3731 21.0448 13.0593 21.3183 13.0593 21.6514L13.0593 23.1626C13.0593 23.4957 13.3731 23.7692 13.7566 23.7692L20.4571 23.7692C20.8441 23.7692 21.1543 23.4957 21.1543 23.1626Z" fill="url(#paint55_linear_409_2)"/>
    <g style="mix-blend-mode:multiply">
    <path d="M20.4572 21.0448L20.4572 21.739L20.9278 21.739L20.9278 21.2061C20.8023 21.1079 20.6384 21.0448 20.4572 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 21.0378L19.3311 21.739L19.8017 21.739L19.8017 21.0378L19.3311 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 21.0378L18.2015 21.739L18.6722 21.739L18.6722 21.0378L18.2015 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 20.9676L17.072 21.739L17.5427 21.739L17.5427 20.9676L17.072 20.9676Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 21.0448L15.9425 21.739L16.4131 21.739L16.4131 21.0448L15.9425 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 21.0448L14.8164 21.739L15.287 21.739L15.287 21.0448L14.8164 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 21.0448L13.6869 21.739L14.1575 21.739L14.1575 21.0448L13.6869 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M20.9278 22.9978L20.4572 22.9978L20.4572 23.7692C20.6384 23.7692 20.8023 23.7061 20.9278 23.6079L20.9278 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 22.9978L19.3311 23.7692L19.8017 23.7692L19.8017 22.9978L19.3311 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 22.9978L18.2015 23.7692L18.6722 23.7692L18.6722 22.9978L18.2015 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 22.9978L17.072 23.7692L17.5427 23.7692L17.5427 22.9978L17.072 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 22.9978L15.9425 23.7692L16.4131 23.7692L16.4131 22.9978L15.9425 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 22.9978L14.8164 23.7692L15.287 23.7692L15.287 22.9978L14.8164 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 22.9978L13.6869 23.7692L14.1575 23.7692L14.1575 22.9978L13.6869 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 22.0195L19.8296 22.7909L20.3002 22.7909L20.3002 22.0195L19.8296 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 22.0195L18.7035 22.7909L19.1741 22.7909L19.1741 22.0195L18.7035 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 22.0195L17.574 22.7909L18.0446 22.7909L18.0446 22.0195L17.574 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 22.0195L16.4445 22.7909L16.9151 22.7909L16.9151 22.0195L16.4445 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 22.0195L15.3184 22.7909L15.789 22.7909L15.789 22.0195L15.3184 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 22.0195L14.1888 22.7909L14.6595 22.7909L14.6595 22.0195L14.1888 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M20.4572 22.0195L20.4572 22.7909L20.9278 22.7909L20.9278 22.0195L20.4572 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M19.3311 22.0195L19.3311 22.7909L19.8017 22.7909L19.8017 22.0195L19.3311 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.2015 22.0195L18.2015 22.7909L18.6722 22.7909L18.6722 22.0195L18.2015 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.072 22.0195L17.072 22.7909L17.5427 22.7909L17.5427 22.0195L17.072 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.9425 22.0195L15.9425 22.7909L16.4131 22.7909L16.4131 22.0195L15.9425 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.8164 22.0195L14.8164 22.7909L15.287 22.7909L15.287 22.0195L14.8164 22.0195Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M13.6869 22.0195L13.6869 22.7909L14.1575 22.7909L14.1575 22.0195L13.6869 22.0195Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 22.9978L19.8296 23.7692L20.3002 23.7692L20.3002 22.9978L19.8296 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 22.9978L18.7035 23.7692L19.1741 23.7692L19.1741 22.9978L18.7035 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 22.9978L17.574 23.7692L18.0446 23.7692L18.0446 22.9978L17.574 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 22.9978L16.4445 23.7692L16.9151 23.7692L16.9151 22.9978L16.4445 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 22.9978L15.3184 23.7692L15.789 23.7692L15.789 22.9978L15.3184 22.9978Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 22.9978L14.1888 23.7692L14.6595 23.7692L14.6595 22.9978L14.1888 22.9978Z" fill="#636363"/>
    </g>
    </g>
    <g style="mix-blend-mode:screen">
    <g style="mix-blend-mode:multiply">
    <path d="M19.8296 21.0378L19.8296 21.739L20.3002 21.739L20.3002 21.0378L19.8296 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M18.7035 21.0378L18.7035 21.739L19.1741 21.739L19.1741 21.0378L18.7035 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M17.574 21.0378L17.574 21.739L18.0446 21.739L18.0446 21.0378L17.574 21.0378Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M16.4445 20.9676L16.4445 21.739L16.9151 21.739L16.9151 20.9676L16.4445 20.9676Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M15.3184 21.0448L15.3184 21.739L15.789 21.739L15.789 21.0448L15.3184 21.0448Z" fill="#636363"/>
    </g>
    <g style="mix-blend-mode:multiply">
    <path d="M14.1888 21.0448L14.1888 21.739L14.6595 21.739L14.6595 21.0448L14.1888 21.0448Z" fill="#636363"/>
    </g>
    </g>
    <path d="M19.1917 11.7987L19.1917 18.5905L20.3212 18.5905L20.3212 11.7987L19.1917 11.7987Z" fill="url(#paint56_linear_409_2)"/>
    <path d="M17.1069 11.7987L17.1069 18.5905L18.2365 18.5905L18.2365 11.7987L17.1069 11.7987Z" fill="url(#paint57_linear_409_2)"/>
    <path d="M15.0221 11.7987L15.0221 18.5905L16.1516 18.5905L16.1516 11.7987L15.0221 11.7987Z" fill="url(#paint58_linear_409_2)"/>
    <path d="M12.9374 11.7987L12.9374 18.5905L14.0669 18.5905L14.0669 11.7987L12.9374 11.7987Z" fill="url(#paint59_linear_409_2)"/>
    <path d="M10.8525 11.7987L10.8525 18.5905L11.9821 18.5905L11.9821 11.7987L10.8525 11.7987Z" fill="url(#paint60_linear_409_2)"/>
    <path d="M8.76782 11.7987L8.76782 18.5905L9.89736 18.5905L9.89736 11.7987L8.76782 11.7987Z" fill="url(#paint61_linear_409_2)"/>
    <path d="M6.68311 11.7987L6.68311 18.5905L7.81264 18.5905L7.81264 11.7987L6.68311 11.7987Z" fill="url(#paint62_linear_409_2)"/>
    <path d="M4.59827 11.7987L4.59827 18.5905L5.7278 18.5905L5.7278 11.7987L4.59827 11.7987Z" fill="url(#paint63_linear_409_2)"/>
    <path d="M25.2089 4.97535L25.2089 9.41785L25.5401 9.41785L25.5401 4.97535L25.2089 4.97535Z" fill="url(#paint64_linear_409_2)"/>
    <path d="M25.2089 21.0167L25.2089 25.4592L25.5401 25.4592L25.5401 21.0167L25.2089 21.0167Z" fill="url(#paint65_linear_409_2)"/>
    <path d="M50.0412 6.79519C51.366 10.014 52.0597 13.608 51.9586 17.3562C52.105 17.3562 52.2515 17.3562 52.3979 17.3527C52.4955 13.5448 51.7913 9.89477 50.4421 6.62338C50.3096 6.67948 50.1737 6.73909 50.0377 6.79519L50.0412 6.79519Z" fill="black"/>
    <path d="M51.9307 13.4712C51.6692 13.4712 51.4565 14.6353 51.4565 16.0694C51.4565 17.5035 51.6692 18.6676 51.9307 18.6676C52.1921 18.6676 52.4048 17.5035 52.4048 16.0694C52.4048 14.6353 52.1921 13.4712 51.9307 13.4712Z" fill="black"/>
    <path d="M0.522949 18.955L0.522949 20.2313L1.03542 20.2313L1.03542 18.955L0.522949 18.955Z" fill="#BE1E2D"/>
    <path d="M0.522949 10.1578L0.522949 11.4341L1.03542 11.4341L1.03542 10.1578L0.522949 10.1578Z" fill="#BE1E2D"/>
    <path d="M63.3167 10.6766L63.3167 19.9263L64 19.0918L64 11.5111L63.3167 10.6766Z" fill="url(#paint66_linear_409_2)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_409_2" x1="31.749" y1="12.8436" x2="31.749" y2="-0.448851" gradientUnits="userSpaceOnUse">
    <stop stop-color="#242424"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint1_linear_409_2" x1="58.9868" y1="4.67725" x2="50.843" y2="4.67725" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint2_linear_409_2" x1="57.2332" y1="8.03284" x2="57.2332" y2="8.03284" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint3_linear_409_2" x1="58.9868" y1="25.6381" x2="50.843" y2="25.6381" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint4_linear_409_2" x1="58.9868" y1="22.286" x2="50.843" y2="22.286" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint5_linear_409_2" x1="29.6538" y1="7.19835" x2="24.2537" y2="7.19835" gradientUnits="userSpaceOnUse">
    <stop stop-color="#1B1C1C"/>
    <stop offset="0.71" stop-color="#262626"/>
    <stop offset="1" stop-color="#9C9C9C"/>
    </linearGradient>
    <linearGradient id="paint6_linear_409_2" x1="57.2333" y1="23.2397" x2="57.2333" y2="23.2397" gradientUnits="userSpaceOnUse">
    <stop stop-color="#1B1C1C"/>
    <stop offset="0.71" stop-color="#262626"/>
    <stop offset="1" stop-color="#9C9C9C"/>
    </linearGradient>
    <linearGradient id="paint7_linear_409_2" x1="26.4325" y1="31.5252" x2="11.6362" y2="12.5964" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint8_linear_409_2" x1="24.902" y1="29.5477" x2="11.8999" y2="12.909" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6D6D6"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint9_linear_409_2" x1="26.938" y1="15.0455" x2="21.9353" y2="15.0455" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint10_linear_409_2" x1="44.885" y1="26.3989" x2="44.885" y2="3.95853" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FCE69C"/>
    <stop offset="0.22" stop-color="#F8B902"/>
    <stop offset="0.77" stop-color="#F09E08"/>
    <stop offset="1" stop-color="#C27500"/>
    </linearGradient>
    <linearGradient id="paint11_linear_409_2" x1="63.2714" y1="15.1788" x2="48.2632" y2="15.1788" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F5A300"/>
    <stop offset="0.18" stop-color="#F6AC01"/>
    <stop offset="0.41" stop-color="#F7B403"/>
    <stop offset="1" stop-color="#BF5409"/>
    </linearGradient>
    <radialGradient id="paint12_radial_409_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(53.1931 8.66734) rotate(-82.453) scale(0.799359 8.12956)">
    <stop stop-color="#828282"/>
    <stop offset="0.18" stop-color="#A2A2A2"/>
    <stop offset="0.43" stop-color="#CACACA"/>
    <stop offset="0.66" stop-color="#E7E7E7"/>
    <stop offset="0.85" stop-color="#F8F8F8"/>
    <stop offset="1" stop-color="white"/>
    </radialGradient>
    <radialGradient id="paint13_radial_409_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(57.7613 9.41217) rotate(-82.453) scale(0.820395 8.34349)">
    <stop stop-color="#828282"/>
    <stop offset="0.18" stop-color="#A2A2A2"/>
    <stop offset="0.43" stop-color="#CACACA"/>
    <stop offset="0.66" stop-color="#E7E7E7"/>
    <stop offset="0.85" stop-color="#F8F8F8"/>
    <stop offset="1" stop-color="white"/>
    </radialGradient>
    <radialGradient id="paint14_radial_409_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(50.7464 8.40301) rotate(-82.453) scale(0.799359 8.12956)">
    <stop stop-color="#828282"/>
    <stop offset="0.18" stop-color="#A2A2A2"/>
    <stop offset="0.43" stop-color="#CACACA"/>
    <stop offset="0.66" stop-color="#E7E7E7"/>
    <stop offset="0.85" stop-color="#F8F8F8"/>
    <stop offset="1" stop-color="white"/>
    </radialGradient>
    <linearGradient id="paint15_linear_409_2" x1="57.3971" y1="6.90388" x2="52.1262" y2="0.818827" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint16_linear_409_2" x1="57.3797" y1="23.5027" x2="52.1544" y2="29.5354" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint17_linear_409_2" x1="59.2447" y1="27.3001" x2="55.5017" y2="22.5068" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint18_linear_409_2" x1="60.6533" y1="26.3989" x2="60.6533" y2="3.95854" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint19_linear_409_2" x1="57.2751" y1="21.3288" x2="57.2751" y2="9.02866" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D2A60E"/>
    <stop offset="0.02" stop-color="#DEB52B"/>
    <stop offset="0.03" stop-color="#E8C142"/>
    <stop offset="0.05" stop-color="#F0CB54"/>
    <stop offset="0.07" stop-color="#F5D261"/>
    <stop offset="0.1" stop-color="#F9D568"/>
    <stop offset="0.16" stop-color="#FAD76B"/>
    <stop offset="0.19" stop-color="#F8D163"/>
    <stop offset="0.3" stop-color="#F5BF4A"/>
    <stop offset="0.4" stop-color="#F2B43A"/>
    <stop offset="0.47" stop-color="#F2B135"/>
    <stop offset="0.56" stop-color="#ECAB30"/>
    <stop offset="0.67" stop-color="#DE9A22"/>
    <stop offset="0.8" stop-color="#C57F0C"/>
    <stop offset="0.86" stop-color="#B87000"/>
    <stop offset="1" stop-color="#543304"/>
    </linearGradient>
    <linearGradient id="paint20_linear_409_2" x1="59.461" y1="4.62479" x2="59.461" y2="4.02521" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F7"/>
    <stop offset="1" stop-color="#DBDBDB"/>
    </linearGradient>
    <linearGradient id="paint21_linear_409_2" x1="59.4645" y1="26.42" x2="59.4645" y2="25.8099" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F7"/>
    <stop offset="1" stop-color="#DBDBDB"/>
    </linearGradient>
    <linearGradient id="paint22_linear_409_2" x1="62.4068" y1="19.9263" x2="62.4068" y2="10.4417" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="#D6D6D6"/>
    </linearGradient>
    <linearGradient id="paint23_linear_409_2" x1="48.2527" y1="24.204" x2="48.2527" y2="26.7566" gradientUnits="userSpaceOnUse">
    <stop stop-color="#C67801"/>
    <stop offset="1" stop-color="#FBDF83"/>
    </linearGradient>
    <linearGradient id="paint24_linear_409_2" x1="48.2527" y1="6.11845" x2="48.2527" y2="3.59391" gradientUnits="userSpaceOnUse">
    <stop stop-color="#ED940A"/>
    <stop offset="1" stop-color="#C67801"/>
    </linearGradient>
    <linearGradient id="paint25_linear_409_2" x1="48.7199" y1="24.8491" x2="48.7199" y2="5.50831" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint26_linear_409_2" x1="30.7658" y1="15.1928" x2="25.9792" y2="15.1928" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F8B902"/>
    <stop offset="1" stop-color="#C27500"/>
    </linearGradient>
    <linearGradient id="paint27_linear_409_2" x1="49.91" y1="4.24631" x2="45.3145" y2="2.24778" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint28_linear_409_2" x1="48.5978" y1="3.74113" x2="48.5978" y2="0.262871" gradientUnits="userSpaceOnUse">
    <stop stop-color="#EC920A"/>
    <stop offset="1" stop-color="#FCC400"/>
    </linearGradient>
    <linearGradient id="paint29_linear_409_2" x1="48.1377" y1="3.76221" x2="48.1377" y2="0.280441" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint30_linear_409_2" x1="49.8875" y1="26.0031" x2="45.2918" y2="28.0051" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint31_linear_409_2" x1="57.2332" y1="26.5217" x2="57.2332" y2="30" gradientUnits="userSpaceOnUse">
    <stop stop-color="#EC920A"/>
    <stop offset="1" stop-color="#FCC400"/>
    </linearGradient>
    <linearGradient id="paint32_linear_409_2" x1="48.1377" y1="26.5007" x2="48.1377" y2="29.979" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint33_linear_409_2" x1="37.1282" y1="24.9333" x2="37.1282" y2="5.52239" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FCC400"/>
    <stop offset="1" stop-color="#EC920A"/>
    </linearGradient>
    <linearGradient id="paint34_linear_409_2" x1="60.8764" y1="6.14999" x2="62.4321" y2="5.81012" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="#363B39"/>
    </linearGradient>
    <linearGradient id="paint35_linear_409_2" x1="61.4969" y1="7.5876" x2="61.4969" y2="4.48101" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F7"/>
    <stop offset="1" stop-color="#DBDBDB"/>
    </linearGradient>
    <linearGradient id="paint36_linear_409_2" x1="60.8764" y1="24.2286" x2="62.4321" y2="24.5684" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="#363B39"/>
    </linearGradient>
    <linearGradient id="paint37_linear_409_2" x1="61.4969" y1="22.7875" x2="61.4969" y2="25.8976" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F7"/>
    <stop offset="1" stop-color="#DBDBDB"/>
    </linearGradient>
    <linearGradient id="paint38_linear_409_2" x1="48.7199" y1="21.3113" x2="48.7199" y2="5.50833" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint39_linear_409_2" x1="44.1529" y1="5.16122" x2="32.8018" y2="5.16122" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint40_linear_409_2" x1="37.2781" y1="6.05884" x2="37.2781" y2="4.32321" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint41_linear_409_2" x1="44.003" y1="25.2068" x2="32.8192" y2="25.2068" gradientUnits="userSpaceOnUse">
    <stop stop-color="#6E6E6E"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint42_linear_409_2" x1="37.0271" y1="24.3022" x2="37.0271" y2="25.9677" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint43_linear_409_2" x1="32.1777" y1="6.05884" x2="32.1777" y2="4.50203" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint44_linear_409_2" x1="32.1777" y1="24.3793" x2="32.1777" y2="25.8555" gradientUnits="userSpaceOnUse">
    <stop stop-color="#737373"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint45_linear_409_2" x1="43.773" y1="15.1507" x2="29.8351" y2="15.1507" gradientUnits="userSpaceOnUse">
    <stop stop-color="#808080"/>
    <stop offset="1" stop-color="#303030"/>
    </linearGradient>
    <linearGradient id="paint46_linear_409_2" x1="44.1495" y1="22.3667" x2="28.8737" y2="4.73263" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint47_linear_409_2" x1="3.53851" y1="19.1024" x2="-0.000814265" y2="14.5744" gradientUnits="userSpaceOnUse">
    <stop stop-color="#949494"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint48_linear_409_2" x1="9.47907" y1="5.07709" x2="1.33527" y2="5.07709" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint49_linear_409_2" x1="9.47907" y1="7.97686" x2="1.33527" y2="7.97686" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint50_linear_409_2" x1="21.3427" y1="5.07709" x2="13.1988" y2="5.07709" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint51_linear_409_2" x1="21.3427" y1="7.97686" x2="13.1988" y2="7.97686" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint52_linear_409_2" x1="9.47907" y1="25.305" x2="1.33527" y2="25.305" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint53_linear_409_2" x1="9.47907" y1="22.4052" x2="1.33527" y2="22.4052" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint54_linear_409_2" x1="21.1439" y1="25.305" x2="13.0001" y2="25.305" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint55_linear_409_2" x1="21.1439" y1="22.4052" x2="13.0001" y2="22.4052" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3B3B3B"/>
    <stop offset="0.35" stop-color="#9C9C9C"/>
    <stop offset="0.67" stop-color="#262626"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <linearGradient id="paint56_linear_409_2" x1="20.3177" y1="15.1928" x2="19.1951" y2="15.1928" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint57_linear_409_2" x1="18.233" y1="30" x2="17.1093" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint58_linear_409_2" x1="16.1481" y1="30" x2="15.0245" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint59_linear_409_2" x1="14.0634" y1="30" x2="12.9397" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint60_linear_409_2" x1="11.9786" y1="30" x2="10.8549" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint61_linear_409_2" x1="9.89387" y1="30" x2="8.77018" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint62_linear_409_2" x1="7.80915" y1="30" x2="6.68546" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint63_linear_409_2" x1="5.72432" y1="30" x2="4.60062" y2="29.653" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="0.13" stop-color="#060606"/>
    <stop offset="0.31" stop-color="#181818"/>
    <stop offset="0.52" stop-color="#363636"/>
    <stop offset="0.75" stop-color="#5F5F5F"/>
    <stop offset="1" stop-color="#949494"/>
    </linearGradient>
    <linearGradient id="paint64_linear_409_2" x1="25.3727" y1="9.35123" x2="25.3727" y2="4.85613" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="1" stop-color="#474747"/>
    </linearGradient>
    <linearGradient id="paint65_linear_409_2" x1="57.2334" y1="25.3926" x2="57.2334" y2="20.8975" gradientUnits="userSpaceOnUse">
    <stop/>
    <stop offset="1" stop-color="#474747"/>
    </linearGradient>
    <linearGradient id="paint66_linear_409_2" x1="63.6548" y1="19.9263" x2="63.6548" y2="10.6766" gradientUnits="userSpaceOnUse">
    <stop stop-color="#363B39"/>
    <stop offset="1" stop-color="#1B1C1C"/>
    </linearGradient>
    <clipPath id="clip0_409_2">
    <rect width="30" height="64" fill="white" transform="translate(0 30) rotate(-90)"/>
    </clipPath>
    </defs>
  </svg>
</template>